import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FORMULAS_OPTIONS_LABELS } from "@shared/constants/formulas-options.constants";
import { FormulasOptions } from "@shared/enums/formulas-options";
import { DividerModule } from "primeng/divider";

@Component({
  selector: "app-warranty-options-mrh",
  standalone: true,
  imports: [CommonModule, TranslateModule, DividerModule],
  templateUrl: "./warranty-options-mrh.component.html",
})
export class WarrantyOptionsMrhComponent {
  @Input() details: any;

  options = FormulasOptions;
  optionsLabels = FORMULAS_OPTIONS_LABELS;

  get enhancements(): any[] {
    return this.details.formulasAndOptionsInformations.enhancements ?? [];
  }

  get RPM(): any {
    return this.enhancements.find((item: any) => item.code === this.options.RPM);
  }

  get ObjVal(): any {
    return this.enhancements.find((item: any) => item.code === this.options.OBJVAL);
  }

  get displayedOptions(): any[] {
    return (this.details.formulasAndOptionsInformations.options ?? []).filter(
      (item: any) => !!this.getOptionLabel(item.type)
    );
  }

  getOptionLabel(type: FormulasOptions): string {
    return this.optionsLabels[type];
  }
}
